var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("PO管理")]),
              _c("el-breadcrumb-item", [_vm._v("开发测试")])
            ],
            1
          )
        ],
        1
      ),
      _c("el-card", { staticClass: "box-card" }, [
        _c("p", { staticClass: "page-desc" }, [
          _vm._v(
            "临时测试入口，手动输入地址访问。后续各类测试接口可在此页追加按钮。"
          )
        ]),
        _c(
          "div",
          { staticClass: "action-list" },
          _vm._l(_vm.testActions, function(item) {
            return _c(
              "div",
              { key: item.key, staticClass: "action-item" },
              [
                _c("div", { staticClass: "action-info" }, [
                  _c("div", { staticClass: "action-title" }, [
                    _vm._v(_vm._s(item.label))
                  ]),
                  _c("div", { staticClass: "action-desc" }, [
                    _vm._v(_vm._s(item.desc))
                  ])
                ]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.loadingKey === item.key
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleRun(item)
                      }
                    }
                  },
                  [_vm._v("\n          执行\n        ")]
                )
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "result-panel" }, [
          _c("div", { staticClass: "result-title" }, [_vm._v("执行结果")]),
          _c("pre", { staticClass: "result-text" }, [
            _vm._v(_vm._s(_vm.displayText))
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }